import { CreditsProvider, useCredits } from 'policy-lib';

/**
 * @todo remove these exports once we've remove uses of
 * EnrichmentCreditsProvider
 */

export const EnrichmentCreditsProvider = CreditsProvider;
export const useEnrichmentCredits = useCredits;